<div data-test="l2CEk4JI" class="modal-compact">
  <div data-test="FX627_Va" class="modal__wrap">
    <div data-test="q49v3sKb" class="modal__window">
      <div data-test="q0nBD7Ir" class="modal__content">
        <button
          data-test="_yf5Y1dm"
          class="modal__close"
          (click)="close()"
          data-close="modal"
        >
          <span data-test="8Z4gtTgS" class="badge badge_gray">
            <i data-test="qraiZrH3" class="material-icons md-12">close</i>
          </span>
        </button>
        <div
          data-test="H9RP9chI"
          class="modal__content-wrap scrollbar-hidden"
          data-simplebar="init"
        >
          <div
            data-test="CYPi88eX"
            class="simplebar-scroll-content"
            style="padding-right: 20px; margin-bottom: -20px"
          >
            <div
              data-test="N3jwdVoT"
              class="simplebar-content"
              style="padding-bottom: 20px"
            >
              <div data-test="R7sE1Z_C" class="modal__container">
                <div data-test="QLLTG-UH" class="modal__body text-left">
                  <div data-test="W-W3XR_M" class="modal__title">
                    <h2 data-test="MJorbk_s">{{ data.title }}</h2>
                  </div>
                  <div
                    data-test="47gZzXeN"
                    class="message-alert"
                    [ngClass]="{
                      'message-alert_warning': data.warning,
                      'message-alert_error': !data.warning && data.error !== false
                    }"
                  >
                    <div data-test="EOiX4lMm" class="message-alert__header">
                      <p
                        *ngIf="data.description"
                        data-test="Vuj9Dztj"
                        class="text-sm"
                        style="white-space: pre-wrap"
                        [style.text-align]="
                          data.descriptionAlignment ||
                          (!data.contentList?.length ? 'center' : '')
                        "
                        [innerHTML]="data.description"
                      ></p>
                    </div>
                    <div
                      data-test="kJE8O810"
                      class="message-alert__text"
                      *ngIf="data.contentList && data.contentList.length"
                    >
                      <ul data-test="v4CmfeRS">
                        <li
                          data-test="icYoAIgW"
                          *ngFor="let message of data.contentList"
                          [innerHTML]="message"
                        ></li>
                      </ul>
                    </div>
                  </div>
                  <div
                    data-test="iCkW1qnz"
                    *ngIf="data.requestData"
                    class="text-center h4"
                  >
                    <a
                      data-test="6EXemcN9"
                      (click)="downloadRequestData()"
                      class="cursor-pointer text-orange"
                    >
                      Download debug data
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer data-test="IXOXgVd2" class="modal__footer modal__footer_white">
          <div data-test="k_6DBKJN" class="modal__container">
            <div data-test="TTRDgbpq" class="modal__footer-wrap row gutters-16">
              <div data-test="NuPQRmVQ" class="col-auto m-auto">
                <button
                  data-test="E__7a-DV"
                  class="button button_primary button_large button_uppercase"
                  (click)="close()"
                >
                  ok
                </button>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  </div>
</div>
